import React from 'react';
import { Descriptions as AntDescriptions, DescriptionsProps } from 'antd';
import { Item } from './Item';

export interface IDescriptionsProps extends DescriptionsProps {}

type TDescriptions = React.FC<IDescriptionsProps> & {
  Item: typeof Item;
};

/**
 * Descriptions component
 */

export const Descriptions: TDescriptions = (props) => (
  <AntDescriptions {...props} />
);

Descriptions.Item = Item;
